import { EXPERIMENT_TYPE } from "../../constants/optimize-constants";

export const getClassifiedConfigEnabled = (classifiedConfig = {}, sortingVariant) => {
    const ignoredSortingVariants = [EXPERIMENT_TYPE.VARIANT_C, EXPERIMENT_TYPE.VARIANT_D];
    const isEnabled = classifiedConfig?.data?.enabled ?? false;
    if (!isEnabled) {
        return false;
    }
    if (!sortingVariant || ignoredSortingVariants.includes(sortingVariant)) {
        return false;
    }
    return true;
};

export default getClassifiedConfigEnabled;
